<template>
  <div :style="{'background-color': backgroundColor, height, width}" class="percentage-tag">
    <p :style="{fontSize: props.size === 'big' ? '24px' : '14px'}">{{ Math.round(props.percentage) }}%</p>
  </div>
</template>

<style lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .percentage-tag {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    padding-bottom: 1px;

    p {
      color: $secondary-color;
      font-family: $bioSans;
      font-style: normal;
      font-weight: 700;
      line-height: 14px;
    }
  }
</style>

<script setup lang="ts">

const props = defineProps({
  percentage: {
    type: Number,
    required: true,
    validator: (val: number) => val >= 0 && val <= 100,
  },
  size: {
    type: String,
    default: 'big',
  }
});

const state = reactive({
  colors: [
    "#822312",
    "#822312",
    "#CD5500",
    "#CD5500",
    "#EDAE39",
    "#EDAE39",
    "#92C93A",
    "#92C93A",
    "#00AF00",
    "#00AF00",
  ],
  rank_colors: {
    A: "#00AF00",
    B: "#92C93A",
    C: "#EDAE39",
    D: "#CD5500",
    E: "#822312",
  },
});

const height = computed(() => props.size === 'big' ? '45px' : '31px');
const width = computed(() => props.size === 'big' ? '80px' : '48px');
const backgroundColor = computed(() => {
  if (props.percentage <= 0) return state.colors[0];
  if (props.percentage >= 100) return state.colors[state.colors.length - 1];
  return state.colors[Math.round((props.percentage) / state.colors.length)];
});

</script>